import { render } from "./PharmacyHome.vue?vue&type=template&id=6868b6f4&ts=true"
import script from "./PharmacyHome.vue?vue&type=script&lang=ts"
export * from "./PharmacyHome.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\winserverroot\\Downloads\\ソース\\netstore-browser-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__